import { Invoice03Icon } from '@hugeicons/core-free-icons';
import { createIcon } from '../icon';

export const ReceiptText = /* @__PURE__ */ createIcon(Invoice03Icon, 'ReceiptText');
